import { useAtom } from "jotai";
import React, { useState } from "react";
import { Button } from "../components/Button";
import { currentUserAtom } from "../jotai/atoms";
import { LOCAL_STORAGE_KEYS } from "../consts";

export default function LogOutButton({ redirect }: { redirect?: string }) {
  const [currentUser] = useAtom(currentUserAtom);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  return (
    <>
      {currentUser ? (
        <Button
          onClick={() => {
            setIsLoggingOut(true);
            logOut(redirect);
          }}
        >
          {isLoggingOut ? "Logging out..." : "Log out"}
        </Button>
      ) : null}
    </>
  );
}

export function logOut(redirect?: string) {
  window.localStorage.removeItem(LOCAL_STORAGE_KEYS.USERNAME);
  window.location.replace(
    `/api/auth/logout${redirect ? `?redirect=${redirect}` : ""}`
  );
}
